import Checkbox from '@mui/material/Checkbox';

import { Box } from '@vk-hr-tek/ui/Box';
import { Tooltip } from '@vk-hr-tek/ui/Tooltip';
import { InputTooltip } from '@vk-hr-tek/ui/InputTooltip';
import { MultipleAutocompleteInputOption } from '@vk-hr-tek/ui/input';
import { Typography } from '@vk-hr-tek/ui/Typography';
import { RenderTags } from '@vk-hr-tek/ui/input/MultipleAutocompleteInput';

import { ValidateType } from '../../validation';
import { MultipleAutocompleteInput } from '../../MultipleAutocompleteInput';

interface OptionType extends MultipleAutocompleteInputOption {
  position?: string;
}

interface PositionsProps {
  name: string;
  label: string;
  placeholder?: string;
  hasEmployees: boolean;
  loading: boolean;
  loadEmployees: (filter: {
    limit: number;
    offset: number;
    query: string;
  }) => Promise<{ label: string; value: string }[]>;
  renderTags: RenderTags;
  validate?: (ValidateType | undefined)[];
  wrapperTooltipText: string;
  inputTooltipText?: string;
}

export const EmployeesInput = ({
  name,
  label,
  placeholder,
  hasEmployees,
  loading,
  loadEmployees,
  renderTags,
  validate,
  wrapperTooltipText,
  inputTooltipText,
}: PositionsProps) => {
  const renderOption = (option: OptionType, value?: string[]) => {
    const isChecked =
      !!value && value.some((item: string) => item === option.value);

    return (
      <Box py="8" display="flex" alignItems="center">
        <Checkbox checked={isChecked} color="primary" />
        <Box display="flex" flexDirection="column">
          <Typography variant="body3">
            {`${option.label}${option.prefix ? `, ${option.prefix}` : ''}`}
          </Typography>
          <Typography variant="caption" color="text.light.tertirary">
            {option.position}
          </Typography>
        </Box>
      </Box>
    );
  };

  return (
    <Box display="flex" flexDirection="column">
      <Tooltip
        title={wrapperTooltipText}
        placement="right"
        disabled={hasEmployees}
      >
        <Box>
          <MultipleAutocompleteInput
            type="load"
            disabled={!hasEmployees}
            loading={loading}
            testId="test-id-employees-multiple-autocomplete-input"
            name={name}
            label={label}
            placeholder={placeholder || label}
            tooltip={
              inputTooltipText ? (
                <InputTooltip description={inputTooltipText} />
              ) : null
            }
            loadItems={loadEmployees}
            renderTags={renderTags}
            renderOption={renderOption}
            validate={validate}
          />
        </Box>
      </Tooltip>
    </Box>
  );
};
